<template>
	<b-container v-if="group.id" fluid>
		<h3><router-link to="/legacy">home</router-link></h3>
		<p>{{ group.description }}</p>
		<template v-if="files.length">
			<ul>
				<li
					v-for="file in files"
					:key="file.id"
					@click="openFile(file.id)"
				>
					{{ file.filename }}
					<span class="file-created">{{ file.created_at }}</span>
				</li>
			</ul>
		</template>
		<template v-else>
			<p>nothing here</p>
		</template>
	</b-container>
</template>

<script>
import {mapActions, mapState} from 'vuex';

export default {
	name: 'Group',
	computed: {
		files() {
			return this.filesByGroup[this.group.id] || [];
		},
		group() {
			return this.groups.find(g => g.name === this.$route.params.groupName) || {};
		},
		...mapState(['filesByGroup', 'groups']),
	},
	async created() {
		await this.fetchGroups();
		this.fetchFiles({groupId: this.group.id});
	},
	methods: {
		openFile(fileId) {
			this.$router.push({
				name: 'file',
				params: {fileId},
			});
		},
		...mapActions(['fetchFiles', 'fetchGroups']),
	}
}
</script>

<style scoped>
	ul {
		padding: 0;
		list-style-type: none;
		width: 30%;
		margin-left: auto;
		margin-right: auto;
	}

	li {
		border: 1px solid white;
		border-radius: 3px;
		padding: 10px;
		margin-bottom: 10px;
		text-align: left;
		cursor: pointer;
		font-size: 1.2rem;
	}

	li:hover {
		background-color: rgb(66, 185, 131);
	}

	.file-created {
		font-size: 0.7rem;
		color: #888;
	}
</style>
